import axios from 'axios';
import authHeader from '../auth-header';

import tokenHeader from '../token-header';

import baseUrl from '../base-url';

const API_URL = baseUrl()+"/api/all/";

const getPeriode = 'periode-rpl';
const postPeriodeUrl = 'periode-rpl';
const putPeriode = 'periode-rpl/';
const deletePeriode = 'periode-rpl/';
const getSelectPeriode = 'periode-rpl-select'
const getPeriodePenerbitanSelect = 'periode-rpl-penerbitan-select'


class PeriodeRplService {

    getPeriodeSelect() {
        return axios.get(
            API_URL + getSelectPeriode ,
            { headers: authHeader() }
        );
    }

    getPeriodePenerbitanSelect() {
        return axios.get(
            API_URL + getPeriodePenerbitanSelect ,
            { headers: authHeader() }
        );
    }

    postPeriode(formData) {
        return axios
            .post(
                API_URL + postPeriodeUrl,
                formData,
                { headers: authHeader() }
            );
    }

    putPeriode(formData) {
        var headers = authHeader();

        return axios
            .put(
                API_URL + putPeriode + formData.idPeriode, formData,
                { headers: authHeader() }
            );
    }

    deletePeriode(formData) {
        var headers = authHeader();

        return axios
            .delete(
                API_URL + deletePeriode + formData.idPeriode,
                { headers: authHeader() }
            );
    }
    // ?pageNo=0&pageSize=10&sortBy=id&filter=r
    getPeriode(currentPage,pageSize,filter){
        
        return axios.get(
            API_URL + getPeriode + '?pageNo=' + currentPage + '&pageSize='+pageSize + '&filter='+filter,
            { headers: authHeader() 
        });
    }

}

export default new PeriodeRplService();